import { useEffect, useRef, useState } from "react"
import { fetchProfileImageUrl } from "../services/HelperService"
import { rootStore } from "../StApp"
// import maleLogo from '../assets/user-male.svg'
// import femaleLogo from '../assets/user-female.svg'
import userLogo from '../assets/user.png'
import { useHistory } from "react-router"

export const ProfileAvatar = ({sex = 'M'}:{sex?: string})=>{

    const [picUrl, setPicUrl] = useState<string>(userLogo)
    const storedProfilePic = useRef<string|null>()
    const history = useHistory()
    
    useEffect(() => {
        async function action() {
            let picUrl = await fetchProfileImageUrl(rootStore.mainStore.uid!, 0)
            if(picUrl)
            { 
                setPicUrl(picUrl)
                storedProfilePic.current = picUrl
            }
        }

        action()
    }, [])

    // useEffect(()=>{
    //     if(storedProfilePic.current)
    //      return
    //     setPicUrl(sex == 'M'? maleLogo: femaleLogo)
    // }, [sex])

    return(
        <div style={{margin: 10}} >
            <img src={picUrl} alt="" className='user-image' onClick={()=>history.push('/stapp/profile')} />
        </div>
    )
}